<template>
    <div v-if="searchUrl" class="row mp-edition-tabs">
        <div class="col-12">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" href="#">{{ translations.records }}</a>
                </li>
                <li class="nav-item">
                    <a :href="searchUrl" class="nav-link">{{ translations.search }}</a>
                </li>
            </ul>
        </div>
    </div>

    <div v-if="showFilter" class="row mp-edition-filter mb-4">
        <div class="col-12 col-sm-6">
            <select v-model="year" class="form-select" @change="search">
                <option selected value="">{{ translations.allYears }}</option>
                <option v-for="year in years" :value="year">{{ year }}</option>
            </select>
        </div>
        <div class="col-12 col-sm-6">
            <select v-model="month" v-if="year !== ''" class="form-select" @change="search">
                <option selected value="">{{ translations.allMonths }}</option>
                <option v-for="month in 12" :value="month" v-html="getMonthName(month)"></option>
            </select>
        </div>
    </div>
    <div class="row items mp-edition-content">
        <article v-for="item in results.data" :key="item.id" class="col-6 col-sm-6 col-md-3">
            <a :href="viewerUrl + '?rid=' + item.id" target="_blank">
                <div class="item">
                    <img :alt="item.Name" :src="getImagePath(item.id)" class="card-img-top">

                    <div class="label">
                        <strong v-if="translations.record">{{ translations.record }}:</strong> {{ item.name }}
                    </div>

                </div>
            </a>
        </article>
    </div>
    <div v-if="showPaging" class="paging">
        <nav aria-label="Page navigation">
            <md-pager :page="pageNumber" :max-page="totalPages" v-on:paging="changePage"></md-pager>
        </nav>
    </div>
</template>

<script>
import axios from 'axios';
import MdPager from './Components/Pager.vue';

export default {
    components: {
        MdPager
    },
    props: {
        pageSize: Number,
        showFilter: Boolean,
        showPaging: Boolean,
        categoryId: {
            type: String,
            default: ''
        },
        page: Number,
        searchUrl: String,
        viewerUrl: String
    },
    data() {
        return {
            year: '',
            month: '',
            query: '',
            totalPages: 0,
            limit: 50,
            offset: 0,
            results: {
                data: [],
                total: 0
            }
        }
    },
    mounted() {
        this.limit = this.pageSize;
        this.offset = (this.page - 1) * this.limit;
        this.search();
    },
    methods: {
        search() {
            let self = this;
            let from = self.getFrom();
            let to = self.getTo();
            axios.get(`/umbraco/mdpaper/record/Search?from=${from}&to=${to}&categoryId=${self.categoryId}&limit=${self.limit}&offset=${self.offset}`).then(res => {
                self.results = res.data;
                self.totalPages = Math.ceil(self.results.total / self.limit);
            });
        },
        getImagePath(recordId) {
            return `/umbraco/mdpaper/page/GetJpgByPageNumber?recordId=${recordId}&pageNumber=1`;
        },
        getMonthName(monthNumber) {
            switch (monthNumber) {
                case 1:
                    return "Januar";
                case 2:
                    return "Februar";
                case 3:
                    return "M&auml;rz";
                case 4:
                    return "April";
                case 5:
                    return "Mai";
                case 6:
                    return "Juni";
                case 7:
                    return "Juli";
                case 8:
                    return "August";
                case 9:
                    return "September";
                case 10:
                    return "Oktober";
                case 11:
                    return "November";
                case 12:
                    return "Dezember";
            }
            return monthNumber;
        },
        changePage(pageNumber) {
            this.offset = (pageNumber - 1) * this.limit;
            this.search();
        },
        getTo() {
            if (this.year !== '' && this.month !== '') {
                let daysInMonth = new Date(this.year, this.month, 0).getDate();
                return `${this.year}-${this.month}-${daysInMonth}T00:00:00Z`;
            }
            if (this.year !== '' && this.month === '') {
                return `${this.year}-12-31T00:00:00Z`;
            }
            return null;
        },
        getFrom() {
            if (this.year !== '' && this.month !== '') {
                return `${this.year}-${this.month}-01T00:00:00Z`;
            }
            if (this.year !== '' && this.month === '') {
                return `${this.year}-01-01T00:00:00Z`;
            }
            return null;
        }
    },
    computed: {
        translations() {
            return multiPaper.listTranslations;
        },
        pageNumber() {
            if (this.offset === 0) {
                return 1;
            }
            return this.offset / this.limit + 1;
        },
        years() {
            let years = [];
            let actualYear = new Date().getFullYear();
            for (let year = actualYear; year >= 2023; year--) {
                years.push(year);
            }
            return years;
        }
    }
}
</script>